<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 42.5 42.5"
    class="close-icon"
  >

    <!-- <circle
      class="cls-1"
      cx="21.25"
      cy="21.25"
      r="20"
      :style="{
        fill: background,
        stroke: circleBorderColor,
        strokeWidth: circleBorderWidth
      }"
    /> -->

    <line
      class="cls-2"
      :x1="lineOne.x1"
      :y1="lineOne.y1"
      :x2="lineOne.x2"
      :y2="lineOne.y2"
      :style="{
        stroke: circleCrossColor,
        strokeWidth: lineWidth,
        strokeLinecap: lineCap
      }"
    />

    <line
      class="cls-2"
      :x1="lineTwo.x1"
      :y1="lineTwo.y1"
      :x2="lineTwo.x2"
      :y2="lineTwo.y2"
      :style="{
        stroke: circleCrossColor,
        strokeWidth: lineWidth,
        strokeLinecap: lineCap
      }"
    />

  </svg>
</template>

<script>
export default {
  name: "CloseIcon",
  props: {
    background: {
      type: String,
      default: 'white'
    },
    circleBorderColor: {
      type: String,
      default: 'black'
    },
    circleBorderWidth: {
      type: String,
      default: '3px'
    },
    circleCrossColor: {
      type: String,
      default: 'black'
    },
    lineWidth: {
      type: String,
      default: '3px'
    },
    lineLength: {
      type: Number,
      default: 20
    },
    lineCap: {
      type: String,
      default: 'butt'
    }
  },
  data() {
    return {
      lineOne: null,
      lineTwo: null
    }
  },
  methods: {
    calcCrossSize() {
      const SVG_SIZE = 42.5
      const LINE = this.lineLength
      const lineOne = {
        x1: (SVG_SIZE - LINE) / 2,
        y1: (SVG_SIZE - LINE) / 2,
        x2: (SVG_SIZE - LINE) / 2 + LINE,
        y2: (SVG_SIZE - LINE) / 2 + LINE,
      }
      const lineTwo = {
        x1: (SVG_SIZE - LINE) / 2 + LINE,
        y1: (SVG_SIZE - LINE) / 2,
        x2: (SVG_SIZE - LINE) / 2,
        y2: (SVG_SIZE - LINE) / 2 + LINE,
      }
      this.lineOne = lineOne
      this.lineTwo = lineTwo
    }
  },
  created() {
    this.calcCrossSize()
  }
}
</script>

<style lang="scss" scoped>
.close-icon {
  width: 100%;
  height: 100%;
  overflow: visible;
  .cls-1,
  .cls-2 {
    stroke-miterlimit: 10;
  }
}
</style>
